// src/client/renderer/shaders/hit-flash.ts
import * as THREE from 'three';
import { VERTEX as HIT_FLASH_VERTEX, FRAGMENT as HIT_FLASH_FRAGMENT } from './hit-flash.glsl';

export interface HitFlashUniforms {
  uIntensity: THREE.IUniform<number>; // 0-1, drives white blend
  uColor: THREE.IUniform<THREE.Color>; // base color (mesh color)
  uTime: THREE.IUniform<number>; // for optional pulse curve
}

/** Pure factory — returns ShaderMaterial. Consumers (Plan 15 hit reaction)
 *  set uIntensity = 1.0 on hit, tween to 0 over ~120ms via gsap registry. */
export function createHitFlashShader(): THREE.ShaderMaterial {
  const uniforms: HitFlashUniforms = {
    uIntensity: { value: 0 },
    uColor: { value: new THREE.Color(1, 1, 1) },
    uTime: { value: 0 },
  };
  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: HIT_FLASH_VERTEX,
    fragmentShader: HIT_FLASH_FRAGMENT,
  });
}
